import EditInterfaceText from '../modules/interface-text/components/EditInterfaceText.vue';
import Vue from 'vue';

var $ = require('jQuery');
var tectoastr = require('tectoastr');
var autosize = require('../vendor/autosize.js');
var config = require('pjax').Config;
var datePicker = require('./datepicker.js');
var tagsInput = require('./tags-input.js');
var Comments = require('./comments.js');
var MarkdownEditor = require('./markdown-editor.js');
var CategorySelector = require('./category-selector.js');
var initVue = require('@/common/vue-fields.js').default;
var currencyFieldInput = require('@/common/currency-input.js');

/**
 * The PJAX module manages the functionality specific to the PJAX bindings and loader
 * management (aka, the cool animations and loader shown during page transitions).
 */

config.set('matchBehaviour', 'all');

// The long timeout is to ensure that we don't get weird cancellation effects for
// semi-long requests (a few hundred ms). Also helps with slow connections.
// jquery-pjax responses will come up "cancelled" if they time out.
var timeout = 40000;
var pjaxContainer = '#pjaxContainer';
var loader = $('#loader');
var body = $('body');
var fatalError = false;
var cancelled = false;

var originalDefaults = $.pjax.defaults;
$.pjax.defaults = {};
$.pjax.defaults.timeout = timeout;
$.pjax.defaults.container = pjaxContainer;
$.pjax.defaults.push = true;
$.pjax.defaults.maxCacheLength = 0;
$.pjax.defaults.version = originalDefaults.version;

var submissionCallback = function(event) {
	$.pjax.submit(event, pjaxContainer);
};

var categorySelectorCallback = function() {
    CategorySelector.setup($('input.category.autocomplete'));
};

var datePickerCallback = function() {
  datePicker.setup($('.date, .datetime, .time'));
};

var tagsInputCallback = function() {
  tagsInput.setup($('.tags-input'));
};

var commentsCallback = function() {
  new Comments($('.comments'));
};

var pageTitleCallback = function() {
  var newTitle = $('#content').find('div[data-title]').first();

  if (newTitle) {
    document.title = newTitle.data('title');
  }
};

var initVueFieldsCallback = function() {
  initVue();
};

var interfaceTextPopoversCallback = function() {
  require('../modules/interface-text/interface-text-popovers.js').init();
};

var navigationCallback = function() {
  $('#wrapper-main-menu').collapse('hide');
};

var pageLoaderCallback = function() {
  document.title = 'Loading...';
};

var addThisCallback = function() {
  // The refresh function is only available if there is at least
  // one website tool enabled in the AddThis UI:
  //
  // https://www.addthis.com/dashboard#gallery/pub/<addthis-code>
  if (
    window.addthis &&
    window.addthis.layers &&
    window.addthis.layers.refresh &&
    typeof window.addthis.layers.refresh === 'function'
  ) {
    addthis.layers.refresh();
  }
};

var filtertronTrayCallback = function() {
  body.pjax('.tray-content a', pjaxContainer);

  $('.tray-content').on('submit', 'form:not(.ignore)', function(event) {
    submissionCallback(event);
  });
};

var markdownEditor = new MarkdownEditor();

var markdownEditorCallback = function() {
  markdownEditor.setup('textarea[class~="mde"]:visible');
  markdownEditor.singleLine('textarea[class~="mde-singleline"]:visible');
};

var currencyFieldInputCallback = function() {
  currencyFieldInput.setup($('.currency-field'));
};

var preserveScrollPosition = function(options) {
  return options && options.push && options.preserveScrollPosition;
}

var setFocus = function(event, xhr, options) {
  if (preserveScrollPosition(options)) {
    return;
  }

  let heading = $('#content').find('h1.sr-only').first();

  if (!heading.length) {
    heading = $('#content').find('.breadcrumbs-list').find('h1').first();
  }

  if (heading.length) {
    heading.attr('tabindex', '-1').focus();
    return;
  }

  // Find h1 rendered in vue templates
  heading = $('#content').find('.selector-title').find('h1').first();

  if(!heading.length) {
    heading = $('#content').find('h1').first();
    heading.attr('tabindex', '-1');
    heading.focus();
    return;
  }

  // If found heading in vue templates without tabindex (first call of this function),
  // add tabindex and call the function again with a delay, as directly focusing the h1 here
  // will not trigger the screen reader.
  if (!heading.attr('tabindex')){
    heading.attr('tabindex', '-1');
    return setTimeout(setFocus, 50);
  }

  // Set focus after delayed recursive call
  heading.focus();
};

// Setup our required PJAX handlers and listeners
body.pjax('#content a:not(.ignore):not([target="_blank"]):not([data-redirector]), #navigation a:not(.ignore), .tray-content a, .pjax-anchor', pjaxContainer);

$('#content, .tray-content').on('submit', 'form:not(.ignore)', function(event) {
	submissionCallback(event);
});

body.on('pjax:end', filtertronTrayCallback);

// Just in case the load time is really fast, we don't bother showing the loader.
body.on('pjax:send', function() {
	loader.delay(150).show().fadeTo(250, 0.8);
});

body.on('pjax:hide', function() {
  loader.hide();
});

// Whenever the loading is complete, we then want to hide the loading animation
body.on('pjax:end', function(event, xhr, options) {

  if (fatalError) {
    fatalError = false;
    return;
  }
  // Hide loader without delaying and reset flag
  else if (cancelled) {
    loader.hide();
    cancelled = false;
    return;
  }

  loader.fadeTo(250, 0, function() { $(this).hide(); });

  // Send user to the top of the page when following pjax links.
  // Preserve the scroll position when using Back/Forward buttons.
  if (!preserveScrollPosition(options)) {
    $('html, body').animate({ scrollTop: 0 }, 250);
  }

  $.ajaxSetup({
      headers: {
          'X-CSRF-TOKEN': $('input[name=_token]').val()
      }
  });

  autosize($('textarea:not(.ignore)'));
});

// Add callbacks to the pjax:end event
body.on('pjax:end', pageTitleCallback);
body.on('pjax:end', datePickerCallback);
body.on('pjax:end', categorySelectorCallback);
body.on('pjax:end', tagsInputCallback);
body.on('pjax:end', commentsCallback);
body.on('pjax:end', addThisCallback);
body.on('pjax:end', navigationCallback);
body.on('pjax:end tabchange', markdownEditorCallback);
body.on('pjax:end', initVueFieldsCallback);
body.on('pjax:end', interfaceTextPopoversCallback);
body.on('pjax:end', currencyFieldInputCallback);
body.on('pjax:end', setFocus);

body.on('pjax:send', pageLoaderCallback);

body.on('pjax:error', function(event, response) {

  // Catch response codes we want to allow PJAX to redirect directly to.
  switch (response.status) {
    case 401:
    case 403:
    case 404:
    case 423:
      fatalError = true;
      return;
  }

  // Catch cancelled requests
  if (response.statusText == 'abort') {
    cancelled = true;
    return;
  }
  // Handle timeouts
  else if (response.statusText == 'timeout') {
    tectoastr.warning($('#lang-strings #alerts-timeout').text());
  }
  // maintenance mode
  else if (response.status == 503) {
    $('#maintenance-modal').modal('show');
  }
  // Handle other errors
  else {
    tectoastr.error($('#lang-strings #alerts-generic').text() + ' [' + response.status + ']');
    throw 'Oops! [' + event.currentTarget.baseURI + '] [' + response.status + ']';
  }

  window.history.back();
  event.preventDefault();
});

autosize($('textarea:not(.ignore)'));

datePickerCallback();
categorySelectorCallback();
tagsInputCallback();
commentsCallback();
markdownEditorCallback();
currencyFieldInputCallback();
initVue();
setFocus();
